// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"qw-z","smallCardRow":"rw-z","largeCardRow":"sw-z","productSearchRow":"tw-z","curatedRow":"uw-z"};